export default __webpack_public_path__ + "static/media/examtantra.16d0a7de.png";